import { NgClass } from '@angular/common';
import { Component, NgZone, OnDestroy, inject } from '@angular/core';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';
import { environment } from '@env/environment';
import { AuthService } from '@service/auth.service';
import { SettingsService } from '@service/settings.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    MatToolbar,
    MatIconButton,
    RouterLink,
    MatIcon,
    NgClass,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatCardActions,
    MatButton
  ],
})
export class LoginComponent implements OnDestroy {
  private router = inject(Router);
  private authService = inject(AuthService);
  private settingsService = inject(SettingsService);
  private ngZone = inject(NgZone);

  /**
   *  The ngDestroyed will be used to kill connections
   * to the store when a component is destroyed
   */
  protected $ngDestroyed = new Subject<void>();
  isDemoMode = environment.environment === 'demo';
  hasSettingNeededForAuth = false;

  constructor() {
    this.authService.canCallApi$.pipe(takeUntil(this.$ngDestroyed)).subscribe(() =>
      this.ngZone.run(() => {
        this.router.navigate(['taskpane', 'home']);
      })
    );
    this.hasSettingNeededForAuth = this.settingsService.hasValidBaseUrl();
    this.settingsService.settingsChange$.pipe(takeUntil(this.$ngDestroyed)).subscribe(() => {
      this.hasSettingNeededForAuth = this.settingsService.hasValidBaseUrl();
    });
  }

  /**
   * Cleanup subscriptions on component destroy.
   */
  ngOnDestroy(): void {
    this.$ngDestroyed.next();
    this.$ngDestroyed.complete();
  }

  /**
   * Initiates the login process.
   */
  login() {
    this.authService.login();
  }
}
